import { Icon } from './Icon'
import { PingPongLandLogo } from './PingPongLandLogo'
import { useStudioStore } from '../store/useStudioStore'
import { AuthIdentity } from './AuthIdentity'

type HeaderProps = {
  experience: 'autonomous' | 'mission'
  onPortal: () => void
  onMissionHub?: () => void
}

export function Header({ experience, onPortal, onMissionHub }: HeaderProps) {
  const {
    mode,
    placedParts,
    setMode,
    save,
    load,
  } = useStudioStore()

  return (
    <header className="header">
      <div className="header-context">
        <button className="brand" type="button" onClick={onPortal} aria-label="핑퐁랜드 활동 선택">
          <PingPongLandLogo />
        </button>

        <div className="project-title">
          {experience === 'mission' && <span>미션 · STAGE 01</span>}
          <strong>{experience === 'mission' ? '첫 번째 장애물' : '자율조립'}</strong>
        </div>
      </div>

      <nav className="mode-tabs" aria-label="작업 모드">
        <button className={mode === 'assembly' ? 'active' : ''} onClick={() => setMode('assembly')}>조립</button>
        <button className={mode === 'coding' ? 'active' : ''} onClick={() => setMode('coding')}>코딩</button>
        <button className={mode === 'simulation' ? 'active' : ''} onClick={() => setMode('simulation')}>시뮬레이션</button>
      </nav>

      <div className="header-actions">
        {experience === 'mission' && <button type="button" onClick={onMissionHub}>미션 목록</button>}
        {mode === 'assembly' && experience === 'autonomous' && (
          <>
            <button className="save-action" onClick={save} disabled={!placedParts.length}><Icon name="save" size={15} /> 조립 저장</button>
            <button onClick={load}>불러오기</button>
          </>
        )}
        {mode === 'assembly' && experience === 'mission' && <span className="mission-limit-chip">부품 8개 제한</span>}
        <AuthIdentity className="profile" eyebrow="현재 사용자" />
      </div>
    </header>
  )
}
